import { render, staticRenderFns } from "./OnboardingStep.vue?vue&type=template&id=7a03dfde&"
import script from "./OnboardingStep.vue?vue&type=script&lang=js&"
export * from "./OnboardingStep.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports